import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/domain-register',
    name: 'RegisterDomainPage',
    component: () => import('@/modules/domains/views/RegisterDomainPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/domain-transfer',
    name: 'TransferDomainPage',
    component: () => import('@/modules/domains/views/TransferDomainPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/domain-configure',
    name: 'ConfigureDomainPage',
    component: () => import('@/modules/domains/views/ConfigureDomainPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
